export default __webpack_public_path__ + "static/media/project_lg_autopartes_2.52c0ff0e.png";